import React, { Component } from "react";
import { translate } from "react-i18next";
import { setLoading } from '../../commons/components/application/miscActions';
import { getFirstHundredAutoReplyRules, getReplyTemplates, saveAutoReplyRule, deleteAutoReplyRule, saveReplyTemplate } from '../../api/feedbackApi';
import { getFlows } from '../../api/flowsApi';
import { connect } from 'react-redux';
import withEventTracking, { trackers } from '../../config/withEventTracking';
import AutoReplyRules from "./AutoReplyRules";

class AutoReplyRulesContainer extends Component {

    constructor(props) {
        super(props);
        this.state = {
        }
        this.trackNotificationVisit = this.trackNotificationVisit.bind(this);
    }

    componentDidMount() {
        console.log("componentDidMount")
        this.trackNotificationVisit();
    }

    trackNotificationVisit = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const comesFromNotification = urlParams.get('comesFromNotification');
        const notificationName = urlParams.get('notificationName');
        const companyId = urlParams.get('companyId');
        const adminId = urlParams.get('adminId');
        const role = urlParams.get('role');

        if (comesFromNotification === 'true' && notificationName && companyId && this.props.trackEvent) {
            this.props.trackEvent(`notification_autoreplyrules_visit`, {
                notificationName: notificationName,
                companyId: companyId,
                adminId: adminId,
                role: role,
                source: 'notification',
                targetPage: 'autoreplyrules',
                comesFromNotification: true
            }, false, [trackers.MIXPANEL]);

            // Clean URL parameters after tracking
            const newUrl = new URL(window.location);
            newUrl.searchParams.delete('comesFromNotification');
            newUrl.searchParams.delete('notificationName');
            newUrl.searchParams.delete('companyId');
            newUrl.searchParams.delete('adminId');
            newUrl.searchParams.delete('role');
            window.history.replaceState({}, '', newUrl.pathname + newUrl.search);
        }
    }

    save = (autoReplyRule) => {
        this.props.setLoading(true);
        const promise = new Promise((resolve) => {
            saveAutoReplyRule(autoReplyRule).then((response) => {
            resolve(response);
          }).finally(() => {
            this.props.setLoading(false);
          });
        })
        return promise;
    }

    render() {
        return (<>
            <AutoReplyRules
                t={this.props.t}
                admin={this.props.admin}
                getRules={getFirstHundredAutoReplyRules}
                getReplyTemplates={getReplyTemplates}
				getFlows={getFlows}
                onSaveAutoReplyRule={this.save}
                onDeleteAutoReplyRule={deleteAutoReplyRule}
                onSaveReplyTemplate={saveReplyTemplate}
                availableCompanies={this.props.availableCompanies}
                selectedCompany={this.props.selectedCompany}
            />
			<br/>
			<br/>
        </>)
    }
    
}

function mapStateToProps(state) {
    return {
        admin: state.login.admin,
        availableCompanies: state.application.availableCompanies,
        selectedCompany: state.application.selectedCompany
    };
}

function mapDispatchToProps(dispatch) {
    return {
        setLoading: (loading) => dispatch(setLoading(loading))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(translate('common')(withEventTracking(AutoReplyRulesContainer))); 
